import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class OperationalLimitProvider extends HttpService {

    /**
     * Serviço de integração ao backend de Limite Operacional
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('operationalLimitApi', http, settingsService);
    }

}
